export default __webpack_public_path__ + "static/bg-e3c80a9df01590773e4d1432ba28050d.png";